import { type OverlayEngine } from '@/overlay';

/**
 * viewer 전역 API(`invalidateCanvas` 등)와 측정 판정 래퍼가 가리키는 활성 오버레이 엔진.
 * viewer 는 전역 canvasStore 의 단일 활성 캔버스를 전제로 하므로 마지막으로 마운트된
 * `OverlayManagerProvider` 의 엔진 하나만 가리킵니다. 시뮬레이션 엔진은 여기에 등록하지 않습니다.
 */
let activeEngine: Nullish<OverlayEngine> = null;

export const getActiveViewerOverlayEngine = (): Nullish<OverlayEngine> =>
  activeEngine;

export const setActiveViewerOverlayEngine = (
  engine: Nullish<OverlayEngine>,
) => {
  activeEngine = engine;
};

/** 해당 엔진이 아직 활성일 때만 해제합니다(뒤이어 마운트된 다른 Provider 를 지우지 않기 위함). */
export const clearActiveViewerOverlayEngine = (engine: OverlayEngine) => {
  if (activeEngine === engine) activeEngine = null;
};
